"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentType = void 0;
var defs_1 = require("./defs");
var PaymentType = (function () {
    function PaymentType(paymentType) {
        this.paymentType = paymentType;
    }
    PaymentType.from = function (paymentType) {
        return new PaymentType(paymentType);
    };
    PaymentType.prototype.toString = function () {
        return this.paymentType;
    };
    PaymentType.prototype.toEnum = function () {
        return this.paymentType;
    };
    PaymentType.prototype.isIndiSubscription = function () {
        switch (this.paymentType) {
            case defs_1.PAYMENT_TYPE.INDI_TRIAL:
            case defs_1.PAYMENT_TYPE.INDI_SUBSCRIBE:
            case defs_1.PAYMENT_TYPE.INDI_PROLONG: return true;
            default: return false;
        }
    };
    PaymentType.prototype.is = function (paymentType) {
        return this.paymentType === paymentType;
    };
    return PaymentType;
}());
exports.PaymentType = PaymentType;
